import KpiPage from './KpiPage';

const FrequencyPage = (props) => {
    const year = 2022; // Example year
    const pageId = 19; // Example page ID


    return (
        <KpiPage year={year} pageId={pageId} pageIdentifier={props.pageIdentifier} />
    );
};

export default FrequencyPage;